import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  videos: [],
  uploadingVideo: null,
  selectedFile: null,
};

export const videosSlice = createSlice({
  name: "videos",
  initialState,
  reducers: {
    setVideos: (state, action) => {
      state.videos = action.payload;
    },
    setUploadingVideo: (state, action) => {
      state.uploadingVideo = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    addDummyVideo: (state, action) => {
      state.videos.unshift(action.payload);
    },
    updateVideo: (state, action) => {
      const { id, updates } = action.payload;
      state.videos = state.videos.map((video) =>
        video.id === id ? { ...video, ...updates } : video
      );
    },
    removeVideo: (state, action) => {
      state.videos = state.videos.filter(
        (video) => video.id !== action.payload
      );
    },
    removeUploadingVideos: (state) => {
      state.videos = state.videos.filter((video) => !video.isUploading);
    },
  },
});

export const {
  setVideos,
  setUploadingVideo,
  setSelectedFile,
  addDummyVideo,
  updateVideo,
  removeVideo,
  removeUploadingVideos,
} = videosSlice.actions;

export const selectVideos = (state) => state.videos.videos;
export const selectUploadingVideo = (state) => state.videos.uploadingVideo;
export const selectSelectedFile = (state) => state.videos.selectedFile;

export default videosSlice.reducer;
